










import { Component, Vue, Watch } from "vue-property-decorator";
import headerCom from "@/components/headerCom.vue";
import suspensionBar from "@/components/suspensionBar.vue";

@Component({
  components: { headerCom, suspensionBar },
})
export default class Home extends Vue {}
